module.exports = __webpack_public_path__ + "static/media/tastemakers-campus.ff2a3d63.jpg";